export default "__VITE_ASSET__CMXQgHiH__"